import '../styles/ChampiItem.css';
import { caracteristiqueLibelle } from './ChampignonsList';

function ChampiItem({ id, champiDuJourId, cover, commons = {}, ...props }) {

  return (
    <li key={id} className={`mycoquiz-champi-item ${id === champiDuJourId ? 'champion-du-jour' : ''}`}>
      <img className='mycoquiz-champi-item-cover' src={cover} alt={`${props.nom} cover`} />
      <div>
        <h3>{props.nom}</h3>
        <ul>
          {Object.keys(caracteristiqueLibelle).map((key) => {
            if (!props[key]) return null;
            const isCommon = commons[key] && commons[key].length > 0;

            return (
              <li key={key} className={!isCommon ? 'disabled' : ''}>
                <strong>{caracteristiqueLibelle[key]}:</strong> {props[key]}
              </li>
            );
          })}
        </ul>
      </div>
    </li>
  );
}

export default ChampiItem;